import React from 'react'
import { AdvancedFilter } from 'components/Filter/AdvancedFilter'
import { ARScheduledBillingMain } from './ARScheduledBillingMain'
import { ARScheduledBillingForm } from './ARScheduledBillingForm/ARScheduledBillingForm'
import { ARSchedullingBillingDetail } from './ARScheduledBillingDetail/ARScheduledBillingDetail'
import { ARGenerateScheduledBillingForm } from './ARGenerateScheduledBillingForm/ARGenerateScheduledBillingForm'
import { ARGenerateScheduledBillingMain } from './ARGenerateScheduledBillingMain'
import { ARGenerateScheduledBillingDetail } from './ARGenerateScheduledBillingDetail/ARGenerateScheduledBillingDetail'

const arSceduledBillingRoutes = [
  /* -------------------------------------------- */
  /*                ADVANCED FILTER               */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/scheduled-billing/sales-order/filter',
    },
    component: (
      <AdvancedFilter
        mode="scheduled-billing"
        app="account-receivable"
        hasStatus
        hasDocDate
        hasDateRange
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/scheduled-billing/generate-scheduled-billing/filter',
    },
    component: (
      <AdvancedFilter
        mode="scheduled-billing"
        app="account-receivable"
        hasStatus
        hasDocDate
        hasDateRange
      />
    ),
  },
  /* -------------------------------------------- */
  /*                     MAIN                     */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path: '/account-receivable/:CompanyID/scheduled-billing/sales-order',
    },
    component: <ARScheduledBillingMain />,
  },
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/scheduled-billing/generate-scheduled-billing',
    },
    component: <ARGenerateScheduledBillingMain />,
  },
  /* -------------------------------------------- */
  /*                     FORM                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path: '/account-receivable/:CompanyID/scheduled-billing/sales-order/add',
    },
    component: (
      <ARScheduledBillingForm formMode="add" type="SCHEDULED_BILLING" />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/scheduled-billing/generate-scheduled-billing/add',
    },
    component: (
      <ARGenerateScheduledBillingForm
        formMode="add"
        type="GENERATE_SCHEDULED_BILLING"
      />
    ),
  },

  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/proforma-invoices/issue-actual-invoice/edit',
    },
    component: (
      <ARGenerateScheduledBillingForm // re-use template for faster implementation
        formMode="edit"
        type="ISSUE_ACTUAL_INVOICE"
      />
    ),
  },

  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/scheduled-billing/sales-order/:ScheduledBillingID/edit',
    },
    component: <ARScheduledBillingForm formMode="edit" />,
  },
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/scheduled-billing/sales-order/:ScheduledBillingID/approve-reject',
    },
    component: <ARScheduledBillingForm mode="approve-reject" />,
  },

  /* -------------------------------------------- */
  /*                    DETAIL                    */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/scheduled-billing/sales-order/:ScheduledBillingID/detail',
    },
    component: <ARSchedullingBillingDetail />,
  },

  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/scheduled-billing/generate-scheduled-billing/:ScheduledBillingID/detail',
    },
    component: <ARGenerateScheduledBillingDetail />,
  },
]

export default arSceduledBillingRoutes
